var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-groups"},[_c('Body'),_c('MainAsideRight',{attrs:{"is-open":_vm.isOpen,"aside-can-save":_vm.canSave,"store-path":"users"}},[_c('Aside')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }